import * as Util from './util.js';

class Parallax
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Parallax
	// ---------------------------------------------------------------------------------------------------------

  constructor(group){
    
    //参照
    this.group = group;
    
    //スクロールのハンドリング
    $(window).scroll(this.onScroll.bind(this));
    this.onScroll();
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	スクロールハンドリング
	// ---------------------------------------------------------------------------------------------------------

  /**
   * スクロール
   */
  onScroll(e){
    
    //座標計算
    const scrollY = $(window).scrollTop();
    const minY = this.group.offset().top - $(window).height();
    const maxY = this.group.offset().top + this.group.outerHeight() - $("header").outerHeight();
    
    //レート計算
    let scrollRate = (scrollY - minY) / (maxY - minY);
    if(scrollRate < 0)
    {
      scrollRate = 0;
    }
    else if(scrollRate > 1)
    {
      scrollRate = 1;
    }
    
    //アイテムの更新
    this.group.find(".js-parallax-item").each(function(index){
      const item = $(this);
      const model = (Util.isSP())? item.data("model").sp : item.data("model").pc;
      TweenMax.set(item, {y:model.from + model.range*scrollRate});
    });
  }
  
  // ---------------------------------------------------------------------------------------------------------
}

export default Parallax;
